import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";
import auth from "../../auth";
import axios from "axios";
import InputMask from 'react-input-mask';

import Datetime from 'react-datetime';

import { Table, Nav, NavItem, NavLink, Row, Button, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import moment from 'moment';

class ModalAHistorico extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitudes: [],
            año: moment(),
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            solicitudes: [],
            año: moment(),
        })
    }
    
    getData(){
        const { solicitudes, año } = this.state;

        let añoAux = año.format('YYYY');

        return {solicitudes, año: añoAux}
    }

    setSelects(data) {

    }

    onValidation(){
        const { solicitudes, año } = this.state;

        if((typeof(año)!='string') && (solicitudes.length>0)){
            return true;
        }

        return false;
    }

    onOpen = () => {
        let selectedRows = this.props.rows();
        if(selectedRows.length>0){
            let solicitudes = [];
            selectedRows.forEach((row)=>{
                solicitudes.push(row.plan__solicitud_id);
            })
            this.setState({
                solicitudes: solicitudes,
            })
        }
    }


    render() {
        const { solicitudes } = this.state;
        return (
            <ParadigmaModal
                // getUrl={api.proyectos.presupuesto.edit}
                postUrl={api.proyectos.solicitudes.cambiarahistorico}
                onSubmit={(e) => {this.props.onSubmit(e)}}
                id={this.props.id}
                successMessage={"El Presupuesto ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Presupuesto ya se encuentra cerrado."}
                title={"Pasar Proyectos a Historicos"}
                buttonTitle={"Pasar Proyectos a Historicos"}
                // buttonIcon={"fa fa-history fa-lg"}
                buttonIcon={"fa fa-indent fa-lg"}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}
                onOpen={() => this.onOpen()}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                multiselect={true}
                backdropToggle={true}
            >
                {this.props.multiSelectIDs() ? 
                <Fragment>
                    <Row className={'mt-2 mb-3'}>
                        <Col className={'col-12'}>
                            <div className={"table-historico"}>
                                <Table className="table-sm">
                                        <thead>
                                            <tr>
                                                <th width={"100px"}>Codigo</th>
                                                <th>Nombre</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.rows().map((e, i)=>
                                            <tr key={i}>
                                                <td>
                                                    {(e.plan__solicitud__codigo) ? (e.plan__solicitud__codigo) : ''}
                                                </td>
                                                <td>
                                                    {(e.plan__solicitud__nombre) ? (e.plan__solicitud__nombre) : ''}
                                                </td>
                                            </tr>)}
                                        </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={'col-auto'}>
                            <Label className="display-inline-block">Año</Label>
                        </Col>
                        <Col className={'col-8'}>
                            <Datetime
                                className="display-inline-block input-year"
                                dateFormat="YYYY"
                                inputProps={{ maxLength: 4 }}
                                defaultValue={moment()}
                                closeOnSelect={true}
                                onChange={(data) => this.setState({año: data})}
                            />
                        </Col>
                    </Row>
                </Fragment>
                :
                    <Row>
                        <Col className={'col-12 text-center'}>
                            <h3>Debe seleccionar una fila.</h3>
                        </Col>
                    </Row>
                }
            
            </ParadigmaModal>
        );
    }
}

export default ModalAHistorico;



// WEBPACK FOOTER //
// ./src/views/ProyectosHistoricos/ModalAHistorico.js